import cookie from "js-cookie";
import Vue from "vue";
import Vuex from "vuex";

import actions, {
    AppActionTypes,
    GetSettings,
    GetUser,
    GetValidationRules,
    restClient
} from "./actions";
import getters, { AppGetterTypes, GetPropertyValidationRules } from "./getters";
import IAppState from "./IAppState";
import mutations, { AppMutationTypes } from "./mutations";

// https://vuex.vuejs.org/
Vue.use(Vuex);

const initialState: IAppState = {
    roleItems: [],
    roleValues: {},
    version: process.env.VUE_APP_VERSION || "",
    environmentAlert: "",
    validationRules: {},
    token: cookie.get("token") || ""
};

const store = new Vuex.Store({
    state: initialState,

    // https://vuex.vuejs.org/guide/getters.html
    getters: getters,

    // https://vuex.vuejs.org/guide/mutations.html
    mutations: mutations,

    // https://vuex.vuejs.org/guide/actions.html
    actions: actions,

    // https://vuex.vuejs.org/guide/modules.html
    modules: {}
});

/**
 * Sets the authentication token in a cookie, default restClient, and commits to the store.
 * @param token Bearer token for API authentication
 */
export function setAuthToken(token?: string): void {
    if (token) {
        cookie.set("token", token);
        restClient.setAuthorizationHeader(token);
        store.dispatch(AppActionTypes.getUser);
    } else {
        cookie.remove("token");
        store.commit(AppMutationTypes.setUser, undefined);
    }
    store.commit(AppMutationTypes.setToken, token);
}

if (initialState.token) {
    setAuthToken(initialState.token);
}

export default store;

export {
    AppGetterTypes,
    AppMutationTypes,
    AppActionTypes,
    GetPropertyValidationRules,
    GetValidationRules,
    GetSettings,
    GetUser,
    restClient
};
